import { render, staticRenderFns } from "./AboutPeoplesBehind.vue?vue&type=template&id=4ed6eb9a&scoped=true&"
import script from "./AboutPeoplesBehind.vue?vue&type=script&lang=js&"
export * from "./AboutPeoplesBehind.vue?vue&type=script&lang=js&"
import style0 from "./AboutPeoplesBehind.vue?vue&type=style&index=0&id=4ed6eb9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed6eb9a",
  null
  
)

export default component.exports